import type { ReactNode } from "react";

export type typeSystemLineProps = {
  text: string;
};

/** A centered, neutral line, used for both an ordinary system announcement
 * and a deleted-message tombstone. This component has no opinion on which
 * case it is in; the caller passes whatever text applies. */
export const SystemLine = (props: typeSystemLineProps): ReactNode => {
  return (
    <div className="flex justify-center py-1">
      <p className="text-caption text-ink-tertiary">{props.text}</p>
    </div>
  );
};
